import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const GridViewIcon = ({
  width = "26",
  height = "26",
  color = "#1C3C6C",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.1667 22.1V15.8167C15.1667 15.6443 15.2351 15.4789 15.357 15.357C15.4789 15.2351 15.6443 15.1667 15.8167 15.1667H22.1C22.2724 15.1667 22.4377 15.2351 22.5596 15.357C22.6815 15.4789 22.75 15.6443 22.75 15.8167V22.1C22.75 22.2724 22.6815 22.4377 22.5596 22.5596C22.4377 22.6815 22.2724 22.75 22.1 22.75H15.8167C15.6443 22.75 15.4789 22.6815 15.357 22.5596C15.2351 22.4377 15.1667 22.2724 15.1667 22.1ZM3.25 22.1V15.8167C3.25 15.6443 3.31848 15.4789 3.44038 15.357C3.56228 15.2351 3.72761 15.1667 3.9 15.1667H10.1833C10.3557 15.1667 10.5211 15.2351 10.643 15.357C10.7649 15.4789 10.8333 15.6443 10.8333 15.8167V22.1C10.8333 22.2724 10.7649 22.4377 10.643 22.5596C10.5211 22.6815 10.3557 22.75 10.1833 22.75H3.9C3.72761 22.75 3.56228 22.6815 3.44038 22.5596C3.31848 22.4377 3.25 22.2724 3.25 22.1ZM15.1667 10.1833V3.9C15.1667 3.72761 15.2351 3.56228 15.357 3.44038C15.4789 3.31848 15.6443 3.25 15.8167 3.25H22.1C22.2724 3.25 22.4377 3.31848 22.5596 3.44038C22.6815 3.56228 22.75 3.72761 22.75 3.9V10.1833C22.75 10.3557 22.6815 10.5211 22.5596 10.643C22.4377 10.7649 22.2724 10.8333 22.1 10.8333H15.8167C15.6443 10.8333 15.4789 10.7649 15.357 10.643C15.2351 10.5211 15.1667 10.3557 15.1667 10.1833ZM3.25 10.1833V3.9C3.25 3.72761 3.31848 3.56228 3.44038 3.44038C3.56228 3.31848 3.72761 3.25 3.9 3.25H10.1833C10.3557 3.25 10.5211 3.31848 10.643 3.44038C10.7649 3.56228 10.8333 3.72761 10.8333 3.9V10.1833C10.8333 10.3557 10.7649 10.5211 10.643 10.643C10.5211 10.7649 10.3557 10.8333 10.1833 10.8333H3.9C3.72761 10.8333 3.56228 10.7649 3.44038 10.643C3.31848 10.5211 3.25 10.3557 3.25 10.1833Z"
          stroke={color}
          strokeWidth="1.5"
        />
      </svg>
    </IconWrapper>
  );
};
